import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

import { booleanSchema } from '~/utils/schemas';

// We manually set the shared env variables in the window object
// using PublicEnv component.
const src = typeof document === 'undefined' ? process.env : window.ENV;

export const env = createEnv({
  server: {
    SESSION_SECRET: z.string().min(1),
  },
  shared: {
    PUBLIC_ENVIRONMENT: z.enum(['local', 'development', 'production', 'ci']),
    PUBLIC_API_URL: z.string().url(),
    PUBLIC_CDN_URL: z.string().url(),
    PUBLIC_POSTHOG_API_TOKEN: z.string(),
    PUBLIC_POSTHOG_API_HOST: z.string().url(),
    PUBLIC_ENABLE_INTERCOM: booleanSchema.optional(),
    PUBLIC_ENABLE_SENTRY: booleanSchema.default(false),
    PUBLIC_MIXPANEL_TOKEN: z.string().optional(),
    PUBLIC_HOTJAR_ID: z.coerce.number().optional(),
  },
  client: {
    PUBLIC_GOOGLE_DESTINATION_ID: z.string().optional(),
    PUBLIC_ENABLE_CONSOLE_LOGS: booleanSchema.optional(),
    PUBLIC_ENABLE_REACT_QUERY_DEVTOOLS: booleanSchema.optional(),
  },
  clientPrefix: 'PUBLIC_',
  runtimeEnv: src,
  emptyStringAsUndefined: true,
});

export type Env = typeof env;

type PublicKeys = keyof typeof env & `PUBLIC_${string}`;
export type PublicEnv = Record<PublicKeys, string>;

// Get all shared and client env variables
// which start with PUBLIC_ prefix
export function getAllPublicEnv() {
  const publicKeys = Object.entries(env)
    .filter((entry): entry is [PublicKeys, string] => entry[0].startsWith('PUBLIC_'))
    .reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {} as PublicEnv);

  return publicKeys;
}
